export const checkWidth = width => {
  let result = width / 2 - 8;
  if (width > 480 && width <= 640) {
    result = width / 2 - 8;
  } else if (width > 640 && width <= 831) {
    result = width / 3 - 8;
  } else if (width > 831) {
    result = width / 4;
  }
  return result;
};



// WEBPACK FOOTER //
// ./src/campaigns/productlist/utils.js